import React, { FC, useEffect, useRef, useState } from 'react';
import { stopDefaultEvents } from '../../utils/DataAccessUtils';

require('./InlineEdit.less');

const InlineEdit: FC<any> = ({
	placeholder,
	value,
	setValue,
	onEnter,
	className,
}): React.ReactElement => {
	const [editingValue, setEditingValue] = useState(value);

	const onChange = (event) => setEditingValue(event.target.value);

	const onKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === 'Escape') {
			event.target.blur();

			if (event.key === 'Enter') {
				onEnter && onEnter();
				stopDefaultEvents(event);
			}
		}
	};

	const onBlur = (event) => {
		// if (event.target.value.trim() === '') {
		// 	setValue(value);
		// } else {
		setValue(event.target.value);
		// }
	};

	const textareaRef = useRef(null);

	const setTextAreaHeight = (el) => {
		el.style.height = 'auto';
		el.style.height = el.scrollHeight + 'px';
	};

	const handleChange = (e) => {
		const el = textareaRef.current;
		setTextAreaHeight(el);
		onChange(e);
	};

	useEffect(() => {
		if (textareaRef.current) {
			const el = textareaRef.current;
			el.focus();

			setTextAreaHeight(el);

			// Move cursor to end
			const length = el.value.length;
			el.setSelectionRange(length, length);
		}
	}, []);

	return (
		<textarea
			ref={textareaRef}
			className={`w-full
        resize-none overflow-hidden
        rounded-md border
        border-0
				border-gray-300
				bg-white
				px-2
        py-1
				outline-none
				ring-0
        focus:border-0
        focus:outline-none
        focus:ring-0 ${className}`}
			rows={1}
			placeholder={placeholder}
			aria-label="Field name"
			value={editingValue}
			onChange={handleChange}
			onKeyDown={onKeyDown}
			onBlur={onBlur}
			autoFocus
		/>
	);
};

export default InlineEdit;
